// export const formatPhoneNumber = (phoneNumber) => {
//     if (!phoneNumber) return "";

//     const cleaned = ("" + phoneNumber).replace(/\D/g, "");
//     const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

//     return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phoneNumber;
//   };

export const formatPhoneNumber = (value) => {
  if (typeof value !== "string") {
    return value; // or return "" if you want to default it to empty
  }

  const cleaned = value.replace(/\D/g, "");
  const digitsOnly = cleaned.slice(-10); // last 10 digits (in case of country code)

  const match = digitsOnly.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

  if (match) {
    return `${match[1]}${match[2] ? `-${match[2]}` : ""}${match[3] ? `-${match[3]}` : ""}`;
  }

  return value;
};



  export const convertToE164 = (phoneNumber) => {
  // Ensure value is a string and remove all non-digit characters
  const cleaned = phoneNumber ? String(phoneNumber).replace(/\D/g, "") : "";

  // If the cleaned number is empty, return an empty string
  if (!cleaned) {
    return "";
  }

  let processedNumber = cleaned;

  // Apply the replacement only if the number has at least 10 digits
  // This prevents replacing digits in incomplete numbers like "12" or "123"
  if (cleaned.length >= 10) {
    // Take the first 10 digits to ensure we're working with a standard length
    const digitsForProcessing = cleaned.substring(0, 10);

    // Replace the first 3 digits with '786'
    // processedNumber = "786" + digitsForProcessing.substring(3);
    processedNumber = digitsForProcessing;
  }

  // Prepend the country code '+1' for E.164 format (assuming US numbers)
  const countryCode = "1";

  // Return the E.164 formatted number
  return `+${countryCode}${processedNumber}`;
};
